import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VAT_RATES = {
  DE: {
    speisen: 7.0,       // ermaessigt (Vor-Ort Verzehr)
    speisen_label: "7% (ermäßigt)",
    getraenke: 19.0,    // regulaer
    getraenke_label: "19% (regulär)",
    standard: 19.0,
    ermaessigt: 7.0,
    lieferung: 19.0,
    fixkosten_options: [0, 7, 19],
    currency_symbol: "€",
    tax_id_label: "USt-IdNr.",
    tax_id_placeholder: "DE123456789",
  },
  AT: {
    speisen: 10.0,      // ermaessigt
    speisen_label: "10% (ermäßigt)",
    getraenke: 20.0,    // regulaer (alkoholische Getraenke)
    getraenke_label: "20% (regulär)",
    standard: 20.0,
    ermaessigt: 10.0,
    ermaessigt2: 13.0,  // Zwischensteuersatz (z.B. Wein ab Hof, Eintritt Kultur)
    lieferung: 10.0,
    fixkosten_options: [0, 10, 13, 20],
    currency_symbol: "€",
    tax_id_label: "UID-Nr.",
    tax_id_placeholder: "ATU12345678",
  },
};

// Module-level cache so we fetch settings only once per session
let _cachedLand = null;
let _pendingFetch = null;

async function fetchLand() {
  if (_cachedLand) return _cachedLand;
  if (_pendingFetch) return _pendingFetch;
  _pendingFetch = axios
    .get(`${API}/unternehmenseinstellungen`, { withCredentials: true })
    .then((res) => {
      const land = res.data?.land === "AT" ? "AT" : "DE";
      _cachedLand = land;
      _pendingFetch = null;
      return land;
    })
    .catch(() => {
      _pendingFetch = null;
      return "DE";
    });
  return _pendingFetch;
}

export function invalidateLandCache() {
  _cachedLand = null;
}

export function useLand() {
  const [land, setLand] = useState(_cachedLand || "DE");
  const [loading, setLoading] = useState(!_cachedLand);

  useEffect(() => {
    let mounted = true;
    fetchLand().then((l) => {
      if (mounted) {
        setLand(l);
        setLoading(false);
      }
    });

    // Re-fetch when tab regains focus or visibility changes
    // (so a Land switch in another tab is picked up live)
    const refetch = () => {
      invalidateLandCache();
      fetchLand().then((l) => {
        if (mounted) setLand(l);
      });
    };
    const onVisibility = () => {
      if (document.visibilityState === "visible") refetch();
    };
    window.addEventListener("focus", refetch);
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      mounted = false;
      window.removeEventListener("focus", refetch);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);

  return {
    land,
    loading,
    vat: VAT_RATES[land],
    isAT: land === "AT",
    isDE: land === "DE",
  };
}

export { VAT_RATES };
